import React from 'react';
import PropTypes from 'prop-types';
import ClickOutside from 'react-click-outside';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';
import Avatar from 'components/Avatar';
import { connect } from 'react-redux';
import { notice } from 'ducks/notifications';
import { Link } from 'react-router-dom';

@connect()

export default class Auth extends Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  state = {
    isOpen: false,
  }

  @autobind
  handleClose() {
    this.setState({ isOpen: false });
  }

  @autobind
  handleOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  @autobind
  handleLogout() {
    this.props.dispatch({
      type: 'LOGOUT',
    });
    this.props.dispatch(notice('Logout.success'));
  }

  render() {
    const { account } = this.props;

    return (
      <div className="Auth">
        <ClickOutside onClickOutside={this.handleClose}>
          <div>
            <button className="Auth__handle" onClick={this.handleOpen}>
              <span className="Auth__handle__name">
                {account.attributes.name}
              </span>
              <Avatar account={account} size={50} />
            </button>
            {
              this.state.isOpen &&
                <div className="Auth__panel">
                  <div className="Auth__panel__box">
                    <div className="Auth__panel__box__avatar">
                      <Avatar account={account} size={40} />
                    </div>
                    <div className="Auth__panel__box__info">
                      <div className="Auth__panel__box__name">
                        {account.attributes.name}
                      </div>
                      <div className="Auth__panel__box__email">
                        {account.attributes.email}
                      </div>
                    </div>
                  </div>
                  <div className="Auth__panel__options">
                    <Link
                      className="Auth__option"
                      to="/account"
                      onClick={this.handleClose}
                    >
                      Edit account
                    </Link>
                    <button
                      className="Auth__option"
                      onClick={this.handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
            }
          </div>
        </ClickOutside>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Auth.jsx